import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // NOTA: NO forzar 'Content-Type' aquí. Axios infiere automáticamente:
  //   - JSON para objetos plain
  //   - multipart/form-data + boundary para FormData
  // Forzar el header aquí rompe los uploads (Iter 153 bug discovery).
});

// Optional Bearer fallback (cookie is primary)
let bearer = null;
export const setBearer = (token) => { bearer = token; };
api.interceptors.request.use((cfg) => {
  if (bearer && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${bearer}`;
  }
  // OLA 5 · Inyecta automáticamente ?empresa_id=... en GETs de obras /
  // licitaciones si el usuario ha seleccionado una filial activa en el topbar.
  try {
    if ((cfg.method || "get").toLowerCase() === "get") {
      const url = (cfg.url || "");
      const aplica = /^\/?(obras|licitaciones)(\/?$|\?)/.test(url);
      if (aplica) {
        const filial = (typeof window !== "undefined")
          ? window.localStorage.getItem("legatum_filial_activa")
          : null;
        if (filial) {
          cfg.params = { ...(cfg.params || {}), empresa_id: filial };
        }
      }
    }
  } catch { /* nunca romper la request */ }
  return cfg;
});

export default api;

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Error inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" · ");
  if (d?.msg) return d.msg;
  if (d?.mensaje) return d.mensaje;
  return String(d);
};

export const formatCurrency = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: "always",
  })
    .format(Number(n || 0));

// Iter 132.A: formato con céntimos exactos (BC3, partidas, comparativas).
// Crítico para no perder precisión en presupuestos / márgenes.
export const formatCurrencyCents = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: "always",
  })
    .format(Number(n || 0));

// Iter 132.A: cadena sin acentos/diacríticos en minúsculas para buscadores.
export const normalizeAccents = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("es-ES", { day: "2-digit", month: "short", year: "numeric" })
      .format(new Date(iso));
  } catch { return iso; }
};
